<template>
  <div>
    <div class="
      voice-demo-card
      uk-tile
      uk-tile-primary
      uk-tile-xsmall
      uk-tile-small@s"
    >
      <div class="uk-flex uk-flex-around uk-margin-small-bottom">
        <div class="
              uk-hr
              uk-position-relative
              uk-width-1-1"
        ></div>

        <svg height="100" width="100" @click="toggleAudio">
           <circle class="stroke stroke-solid" cx="15" cy="15" r="14.5" stroke-dasharray="314"
                   stroke-dashoffset="0"
                   v-bind:stroke="color"
                   :class="{play: !playing}"
                   fill="none"
                   style="stroke-width:1px;
               overflow: hidden"/>

          <line class='line1' x1="11" y1="10" x2="11" y2="20"
                v-bind:stroke="innerColor"
                style="
                stroke-width:2px;
                stroke-linecap: square;"
          />
          <path :id="strokeId" d="M 19 20 L 19 11 L 19 10" rx="10" ry="10"
                v-bind:stroke="innerColor"
                v-bind:fill="innerColor"
                style="stroke-width:2px;
              stroke-linejoin: round;
              stroke-linecap: square;"
          />
          <animate
            v-bind:xlink:href="strokeIdWithHref"
            attributeName="d"
            dur="300ms"
            from="M 19 20 L 19 11 L 19 10"
            to="M 12 20 L 21 15 L 12 10"
            begin="indefinite"
            fill="freeze"
            :id="animationId1"
          />
          <animate
            v-bind:xlink:href="strokeIdWithHref"
            attributeName="d"
            dur="300ms"
            from="M 12 20 L 21 15 L 12 10"
            to="M 19 20 L 19 11 L 19 10"
            fill="freeze"
            :id="animationId2"
            begin="indefinite"
          />
        </svg>

        <div class="
              uk-hr
              uk-position-relative
              uk-width-1-1"
        ></div>
      </div>
      <p><strong>{{ title }}</strong></p>
      <p class="price">{{ price }}</p>
    </div>
  </div>
</template>

<script>
import AudioElement from '@/mixins/AudioElement';
import { generate as shortid } from 'shortid';

export default {
  name: 'VoiceDemoCard.vue',
  mixins: [new AudioElement()],
  data() {
    return {
      uniqueId: undefined,
    };
  },
  computed: {
    animationId1() { return `from_pause_to_play_${this.uniqueId}`; },
    animationId2() { return `from_play_to_pause_${this.uniqueId}`; },
    strokeId() { return `stroke_${this.uniqueId}`; },
    strokeIdWithHref() { return `#stroke_${this.uniqueId}`; },
  },
  props: {
    title: String,
    price: String,
    color: {
      default: '#D8A158',
    },
    innerColor: {
      default: '#FFFFFF',
    },
  },
  watch: {
    playing(value) {
      if (value) {
        this.pause();
      } else {
        this.play();
      }
    },
  },
  methods: {
    pause() {
      document.getElementById(this.animationId2).beginElement();
    },
    play() {
      document.getElementById(this.animationId1).beginElement();
    },
  },
  created() {
    this.uniqueId = shortid();
  },
  mounted() {
    this.play();
  },
};
</script>

<style scoped>
  .voice-demo-card p {
    text-align: center;
    color: #ffffff;
    font-size: 15px;
    margin: 0;
    line-height: 15px;
  }

  .voice-demo-card .uk-hr:first-child {
    margin: 15px 15px 0px 0px;
  }

  .voice-demo-card .uk-hr:last-child {
    margin: 15px 0 0px 0px;
  }

  .offset-3 {
    margin-top: 3px;
  }

  .voice-demo-card p.price {
    color: rgba(128, 156, 177, 1);
    font-size: 12px;
  }

  .icon {
    display: inline-block;
    cursor: pointer;
    --animate-repeat: 100;
  }

  .circle {
    transition: stroke-dashoffset 300ms ease-in;
    stroke-dashoffset: 0;
    fill: none;
  }

  .circle.play {
    opacity: .3;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .stroke-solid {
    stroke-dashoffset: 0;
    stroke-dashArray: 120;
    stroke-width: 4px;
    transition: stroke-dashoffset .75s ease-out,
    opacity 1s ease;
  }

  .icon {
    transform: scale(.8);
    transform-origin: 50% 50%;
    transition: transform 200ms ease-out;
    cursor: pointer;
  }

  .animatedPlayButton {
    cursor: pointer;
  }

  .animatedPlayButton:hover .stroke-solid {
    opacity: 1;
    stroke-dashoffset: -120;
  }

  .animatedPlayButton:hover .icon {
    transform: scale(1.2);
  }
</style>
